import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../components/common/Navbar";
import Footer from "../../components/common/Footer";

import payment from "../../assets/images/payment/payment.png";
import fileInfo from "../../assets/images/payment/fileInfo.png";
import xendit from "../../assets/images/payment/xendit.png";
import useFetch from "../../hooks/useFetch";
import { useParams } from "react-router-dom";
import { ucwords } from "../../utils/Ucwords";
import { number_format } from "../../utils/NumberFormat";

const UserPaymentPage = () => {
  const { externalID } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const trimmedTranNo = externalID.trim();
  const [invoice, setInvoice] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // Fetch basic payment data
  const { data } = useFetch(
    `${API_URL}/payments/${encodeURIComponent(trimmedTranNo)}`
  );

  // Fetch detailed transaction information
  useEffect(() => {
    const fetchTransactionDetails = async () => {
      setIsLoading(true);
      try {
        const requestUrl = `${API_URL}/transaction-details/${encodeURIComponent(
          trimmedTranNo
        )}`;

        const response = await axios.get(requestUrl, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.data.isValid) {
          setInvoice(response.data.invoice);
          setErrors({});
        } else {
          setErrors({
            tranno: response.data.message || "Invalid transaction ID",
          });
        }
      } catch (error) {
        setErrors({
          tranno:
            error.response?.data?.message ||
            "Error fetching transaction details",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (trimmedTranNo) {
      fetchTransactionDetails();
    }
  }, [trimmedTranNo, API_URL]);

  return (
    <>
      <Navbar />
      <div className="flex flex-row w-full mx-auto rounded-lg  h-auto">
        <div
          className="hidden md:flex md:w-1/2 p-10 items-center justify-center relative bg-cover bg-[center_right_20%]"
          style={{ backgroundImage: `url(${payment})` }}
        ></div>

        {/* Right Section - Payment Form */}
        <div className="md:w-1/2 bg-white p-6 mt-16">
          <div className="mb-6">
            <h2 className="text-lg font-bold">
              Total Amount to Pay: ₱{number_format(invoice?.amount)}
            </h2>
          </div>

          <div className="mb-6">
            <div className="w-full bg-white outline-dashed outline-2 outline-[#6AA07F] rounded-lg shadow-md px-10 py-5">
              <div className="flex flex-col items-center mb-4">
                <div className="w-[109px] h-[109px] flex items-center justify-center mb-2">
                  <img src={fileInfo} alt="file info" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">
                  Transaction Information
                </h2>
              </div>

              {isLoading ? (
                <div className="text-center py-4">
                  Loading transaction details...
                </div>
              ) : errors.tranno ? (
                <div className="text-center py-4 text-red-500">
                  {errors.tranno}
                </div>
              ) : data ? (
                <div className="space-y-3 text-xl">
                  <div className="flex justify-between">
                    <span className="text-[#918A8A]">Customer Name</span>
                    <span className="text-gray-900 font-medium">
                      {ucwords(data.fullname || invoice?.customer?.given_names)}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-[#918A8A]">Transaction ID No.</span>
                    <span className="text-gray-900 font-medium">
                      {data.ref_no ? data.ref_no.toUpperCase() : ""}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-[#918A8A]">Service</span>
                    <span className="text-gray-900 font-medium">
                      {data.service ? data.service : ""}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-[#918A8A]">Amount</span>
                    <span className="text-gray-900 font-medium">
                      ₱ {number_format(invoice?.amount)}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="text-center py-4">
                  No transaction data available
                </div>
              )}
            </div>

            <a
              href={invoice?.invoice_url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full block bg-[#82091F] text-white py-3 rounded-full text-center mt-10"
            >
              Pay Now
            </a>
          </div>

          <div className="text-center text-xs text-gray-500 mt-5">
            <p>Your payment is being processed by</p>
            <div className="flex justify-center items-center mt-2">
              <img
                src={xendit}
                className="w-[140.62px] h-[43px]"
                alt="xendit"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserPaymentPage;
